import React from 'react';
import { If } from 'react-if';
import routes from '../../routes';
import Card from '../card/Card';
import CardImage from '../card/CardImage';
import CardContent from '../card/CardContent';
import Anchor from '../Anchor';
import CardIcon from '../card/CardIcon';

const ItemCard = ({
  image, title, description, url, external, icon, qaId,
}) => {
  const destination = external ? routes.Item : url;

  return (
    <Anchor to={destination} params={{ title }} qa-id={qaId}>
      <Card>
        <If condition={!!image && !icon}>
          <CardImage src={image} height={240} />
        </If>

        <If condition={!!icon}>
          <CardIcon icon={icon} />
        </If>

        <CardContent>
          <div className="media">
            <div className="media-content has-text-centered">

              <If condition={!!title}>
                <p className="title is-5">{ title }</p>
              </If>

              <If condition={!!description}>
                <p className="subtitle is-6">{ description }</p>
              </If>
            </div>
          </div>
        </CardContent>
      </Card>
    </Anchor>
  );
};

export default ItemCard;
